import LegalPage from './LegalPage';
const GDPRPolicy = () => <LegalPage pageKey="gdpr" />;
export default GDPRPolicy;
